import { PageContainer, PageContent } from "../components/PageContainer";
import { TitleBar } from "../components/TitleBar";
import { useAtomValue } from "jotai";
import { userAtom } from "../atoms";
import { ImportJson } from "../utils/DataImport";
import { HomePublishSection } from "../components/Publishing";

const SectionCard = ({ children }: { children: React.ReactNode }) => (
  <div className="w-full bg-black/10 p-8 flex flex-col gap-4">{children}</div>
);

const Home = (): JSX.Element => {
  const user = useAtomValue(userAtom);

  // const checkValidation = async () => {
  //   const response = await apiAgent.Auth.validate();
  //   if (response.status === 200) {
  //     tMsg.success("Your login is valid");
  //   } else {
  //     tMsg.warning("Invalid login");
  //   }
  // };

  return (
    <PageContainer>
      <PageContent className="flex flex-col gap-4">
        <TitleBar
          title={user?.username ? `Welcome ${user?.username}!` : "Welcome!"}
        />
        <SectionCard>
          Mildura content management system for the Touchwall
          <HomePublishSection appGroup="touchwall" />
        </SectionCard>
        {/* <SectionCard>
          <div className="font-bold">Data import</div>
          <div>Import old JSON data from previous touchwall CMS</div>
          <ImportJson />
        </SectionCard> */}
      </PageContent>
    </PageContainer>
  );
};

export default Home;
